/* unplugin-vue-components disabled */import { render } from "./FurnaceStatistics.vue?vue&type=template&id=5314265a&scoped=true"
import script from "./FurnaceStatistics.vue?vue&type=script&lang=js"
export * from "./FurnaceStatistics.vue?vue&type=script&lang=js"

import "./FurnaceStatistics.vue?vue&type=style&index=0&id=5314265a&lang=stylus&scoped=true"

import exportComponent from "C:\\Users\\RedFlag\\Desktop\\code\\qms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5314265a"]])

export default __exports__